module.exports = ".update-profile-img {\n  width: 125px;\n  height: 125px; }\n\n.dashed-border {\n  border: 1px dashed #dee2e6; }\n"